// extracted by mini-css-extract-plugin
module.exports = {"deliverySummaryWrapper":"styles-module__deliverySummaryWrapper___NeQvR","discountWrapper":"styles-module__discountWrapper___u0t8h","timeRange":"styles-module__timeRange___1TcK3"};